import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ParamMap } from '@angular/router';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { GeolocationService } from '../geolocation/geolocation.service';
// DO NOT REMOVE [AnalyticsService] - It is necessary for the framework to load
import { AnalyticsService, ConfigService as AnalyticsConfig} from '@wdpr/angular-analytics';
// DO NOT REMOVE [AnalyticsService] - It is necessary for the framework to load

import { ConfigService } from '@app/core/config.service';
import { LoggerService } from '@wdpr/ra-angular-logger';
import { TrackLink } from '@interfaces/track-link';

@Injectable()
export class HomepageAnalyticsService {
    pageKey = false;
    scheduledAnalyticsTrackLinks: TrackLink[] = [];
    private loader: any;
    private siteId = 'dcl';

    constructor(
        private analyticsService: AnalyticsService,
        private analyticsConfig: AnalyticsConfig,
        private configService: ConfigService,
        private logger: LoggerService,
        private httpClient: HttpClient
    ) {
        this.siteId = this.configService.getValue('siteId') || 'dcl';
        this.customLoader();
    }

    initAnalytics() {
        this.analyticsService.getModel().then((model: any) => {
            this.analyticsService.trackPage(model);
        });
    }

    private customLoader() {
        // make changes to analytics configuration here
        this.analyticsConfig.loader = () => {
            return this.httpClient.get('wdpr-web-dcl-homepage/analytics/' + this.siteId + '.site.homepage.json').toPromise();
        };
    }

    trackElement(linkId) {
        this.analyticsService.getModel()
            .then(
                (model: any) => {
                    model.linkId = linkId;
                    this.analyticsService.trackElement(model);
                },
                (error) => {
                    this.logger.error('AnalyticsService::trackLinkId - Analytics model failed');
                }
            );
    }

    trackLinkId(linkId) {
        this.analyticsService.getModel()
            .then(
                (model: any) => {
                    model.linkId = linkId;
                    this.analyticsService.trackLink(model);
                },
                (error) => {
                    this.logger.error('AnalyticsService::trackLinkId - Analytics model failed');
                }
            );
    }

        /**
     * Get the model, set the link ID, and send the model back for tracking
     * @param {string} trackLinkEvent Event to track
     * @param {object} modelProps Additional props to send in the trackLink event
     */
    trackLink(trackLinkEvent: string, modelProps?: object): void {
        console.log('qq analytics trackLink ', this.pageKey);
        this.analyticsService.getModel()
            .then((model: {}) => {
                Object.assign(model, modelProps || {});
                model['events'] = '';
                model['linkId'] = trackLinkEvent;

                this.analyticsService.trackLink(model);
            });
    }
}
